import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const ColumnHeaderSpacedContent = ({
  children
}) => {
  return /*#__PURE__*/_jsx(View, {
    as: "span",
    display: "inline-block",
    marginInlineStart: "300",
    children: children
  });
};
export default ColumnHeaderSpacedContent;